import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import ResourceDetailPage from "./index"


export const VtResourceDetailRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.RESOURCE_DETAIL_PATH,
	title: VISIBILITY_TRACKER_ROUTES.RESOURCE_DETAIL_TITLE,
	icon: 'magnifying-glass',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Jump straight to one VT resource by id and inspect its full data + occurrence ledger',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <ResourceDetailPage />,
		index: true,
	}],
}
